import { Component } from "@angular/core";
import { SmartCheckBoxBlockComponent } from "@sdk/lib/smart-check-box-block/smart-check-box-block/smart-check-box-block.component";
import { injectOptionalTransloco } from "@sdk/lib/utils/optional-transloco";

@Component({
  selector: "app-uplift-user-smart-check-box-block",
  templateUrl: "./uplift-user-smart-check-box-block.component.html",
  styleUrls: ["./uplift-user-smart-check-box-block.component.css"],
})
export class UpliftUserSmartCheckBoxBlockComponent extends SmartCheckBoxBlockComponent {
  private _transloco = injectOptionalTransloco();

  correctAnswerLabel(): string {
    return (
      this._transloco?.translate("sdkBlocks.correctAnswerOne") ??
      "This is a correct answer"
    );
  }

  incorrectAnswerLabel(): string {
    return (
      this._transloco?.translate("sdkBlocks.incorrectAnswer") ??
      "This answer is incorrect"
    );
  }

  viewAnswersLabel(): string {
    return (
      this._transloco?.translate("sdkBlocks.viewAnswers") ?? "View Answers"
    );
  }
}
